import { Product, SkeletonProduct } from "../../types/types";
import { CreditBannerType } from "../../product-list-components/CreditBanner/CreditBanner";

export type CreditBannerDetails = {
  type: CreditBannerType;
  indices: number[];
};

export const getCreditBannerDetails = (
  products: (Product | SkeletonProduct)[],
  chunkSize: number,
): CreditBannerDetails => {
  const firstIfcIndex = products.findIndex(
    (p) =>
      p.__typename !== "SkeletonProduct" &&
      p.credit?.illustration?.financialProductType === "IFC",
  );
  const firstIbcIndex = products.findIndex(
    (p) =>
      p.__typename !== "SkeletonProduct" &&
      p.credit?.illustration?.financialProductType === "IBC",
  );

  if (firstIfcIndex === -1 && firstIbcIndex === -1) {
    return { type: null, indices: [] };
  }
  if (firstIbcIndex === -1) {
    return { type: "IFC", indices: [firstIfcIndex] };
  }
  if (firstIfcIndex === -1) {
    return { type: "IBC", indices: [firstIbcIndex] };
  }
  if (
    Math.floor(firstIfcIndex / chunkSize) ===
    Math.floor(firstIbcIndex / chunkSize)
  ) {
    return {
      type: "IFC-IBC",
      indices: [Math.min(firstIfcIndex, firstIbcIndex)],
    };
  }
  return { type: "IFC-IBC", indices: [firstIbcIndex, firstIfcIndex].sort() };
};
